/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, time: NonNullable<unknown> }} Conflict_Changed_ByInputs */

const en_conflict_changed_by = /** @type {(inputs: Conflict_Changed_ByInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} changed it at ${i?.time}.`)
};

/**
* | output |
* | --- |
* | "{name} changed it at {time}." |
*
* @param {Conflict_Changed_ByInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const conflict_changed_by = /** @type {((inputs: Conflict_Changed_ByInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Conflict_Changed_ByInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_conflict_changed_by(inputs)
});